export const pricingPlans = [
  {
    id: 'pay-per-use',
    name: "Paiement à l'usage",
    subtitle: 'Payez uniquement pour ce que vous utilisez',
    price: '3000',
    currency: 'FCFA',
    period: null,
    features: [
      'Pas d\'abonnement',
      'Génération illimitée',
      'Idéal pour usage occasionnel',
      'Tarifs transparents',
      'Aucun engagement',
    ],
    buttonText: 'Choisir ce plan',
    variant: 'light', 
  },
  {
    id: 'pro',
    name: 'Pro',
    subtitle: 'Abonnement mensuel',
    price: '5 000',
    currency: 'FCFA',
    period: 'Par mois',
    features: [
      'Toutes les applications',
      'Génération illimitée',
      'Support prioritaire',
      'Mises à jour automatiques',
      'Stockage cloud inclus',
    ],
    buttonText: 'Choisir ce plan',
    variant: 'primary',
    featured: true,
  },
  {
    id: 'freemium',
    name: 'Freemium',
    subtitle: 'Découvrez Easy Suite gratuitement',
    price: 'Gratuit',
    currency: null,
    period: null,
    features: [
      'Accès à 3 applications',
      '5 documents par mois',
      'Fonctionnalités de base',
      'Support communautaire',
      'Idéal pour tester',
    ],
    buttonText: 'Commencer gratuitement',
    variant: 'light',
  },
];
